import { WorkshopEquipamentAddApi } from './workshopEquipamentAddApi';
import { CatalogHierarchyService } from '../../../shared/service/catalogHierarchyService';

// Formatadores
function formatEquipmentDetails(data) {
  const equipamento = data.equipamento || data;
  const fotos = data.fotos || [];
  const laudos = data.laudos || [];

  return {
    equipamento: {
      id: equipamento.id,
      nome: equipamento.nome,
      marca: equipamento.marca,
      modelo: equipamento.modelo,
      ca: equipamento.ca,
      serie: equipamento.serie,
      ultima_revisao: equipamento.ultima_revisao,
      proxima_revisao: equipamento.proxima_revisao,
      status: equipamento.status,
      localizacao: equipamento.localizacao,
      obstec: equipamento.obstec,
      user_id: equipamento.user_id,
      servico_id: equipamento.servico_id,
      categoria_id: equipamento.categoria_id,
      produto_id: equipamento.produto_id,
      ativo: equipamento.ativo
    },
    fotos: fotos.map(foto => ({
      id: foto.id,
      nome_arquivo: foto.nome_arquivo,
      nome: foto.nome,
      momento: foto.momento
    })),
    laudos: laudos.map(laudo => ({
      id: laudo.id,
      nome_arquivo: laudo.nome_arquivo,
      nome: laudo.nome,
      descricao: laudo.descricao,
      created_at: laudo.created_at
    }))
  };
}

function formatarData(dataString) {
  if (!dataString) return '--';
  const data = new Date(dataString);
  return data.toLocaleDateString('pt-BR');
}

// Serviços de catálogo hierárquico
function getCategorias() {
  return CatalogHierarchyService.getCategorias();
}

function getProdutosByCategoria(categoriaId) {
  return CatalogHierarchyService.getProdutosByCategoria(categoriaId);
}

function getServicosByProduto(produtoId) {
  return CatalogHierarchyService.getServicosByProduto(produtoId);
}

// Serviços de equipamento
function createEquipment(equipmentData) {
  return WorkshopEquipamentAddApi.createEquipment(equipmentData)
    .then(response => ({
      success: true,
      data: response.data.equipamento || response.data,
      message: response.data.message || "Equipamento criado com sucesso"
    }))
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao criar equipamento");
    });
}

function getEquipmentDetails(id) {
  return WorkshopEquipamentAddApi.getEquipmentDetails(id)
    .then(response => formatEquipmentDetails(response.data))
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao carregar equipamento");
    });
}

function uploadPhoto(equipmentId, photoData) {
  return WorkshopEquipamentAddApi.uploadPhoto(equipmentId, photoData)
    .then(response => ({
      success: true,
      data: response.data,
      message: "Foto enviada com sucesso"
    }))
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao enviar foto");
    });
}

function deletePhoto(equipmentId, photoId) {
  return WorkshopEquipamentAddApi.deletePhoto(equipmentId, photoId)
    .then(response => ({
      success: true,
      message: "Foto excluída com sucesso"
    }))
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao excluir foto");
    });
}

function uploadReport(equipmentId, reportData) {
  return WorkshopEquipamentAddApi.uploadReport(equipmentId, reportData)
    .then(response => ({
      success: true,
      data: response.data,
      message: "Laudo enviado com sucesso"
    }))
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao enviar laudo");
    });
}

function deleteReport(equipmentId, reportId) {
  return WorkshopEquipamentAddApi.deleteReport(equipmentId, reportId)
    .then(response => ({
      success: true,
      message: "Laudo excluído com sucesso"
    }))
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao excluir laudo");
    });
}

export const WorkshopEquipamentAddService = {
  getCategorias,
  getProdutosByCategoria,
  getServicosByProduto,
  createEquipment,
  getEquipmentDetails,
  uploadPhoto,
  deletePhoto,
  uploadReport,
  deleteReport,
  formatarData
};